import { apihubGet, apihubPost, apihubPut, apihubUpload } from "./apihub";
import { buildPath, withQuery } from "./paths";

const ROOT = "/getInteractedCustomerDetail/chatbot-ai-flows";
const CONV_ROOT = "/getInteractedCustomerDetail/conversation-flows";

export function listConversationFlows(query = {}) {
  return apihubGet(withQuery(CONV_ROOT, query));
}

export function getConversationFlowGraph(params = {}, query = {}) {
  return apihubGet(
    withQuery(buildPath(`${CONV_ROOT}/:flowId/graph`, params), query),
  );
}

export function saveConversationFlowGraph(params = {}, payload = {}) {
  return apihubPut(buildPath(`${CONV_ROOT}/:flowId/graph`, params), payload);
}

export function setConversationFlowActive(params = {}, payload = {}) {
  return apihubPut(buildPath(`${CONV_ROOT}/:flowId/active`, params), payload);
}

export function listChatbotAiFlows(query = {}) {
  return apihubGet(withQuery(ROOT, query));
}

export function createChatbotAiFlow(payload = {}) {
  return apihubPost(ROOT, payload);
}

export function getChatbotAiFlowGraph(params = {}, query = {}) {
  return apihubGet(
    withQuery(buildPath(`${ROOT}/:flowId/graph`, params), query),
  );
}

export function saveChatbotAiFlowGraph(params = {}, payload = {}) {
  return apihubPut(buildPath(`${ROOT}/:flowId/graph`, params), payload);
}

export function setChatbotAiFlowActive(params = {}, payload = {}) {
  return apihubPut(buildPath(`${ROOT}/:flowId/active`, params), payload);
}

export function generateChatbotAiFlowFromDoc(formData) {
  return apihubUpload(`${ROOT}/generate-from-doc`, formData);
}
